import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "disabled", "href", "fluid"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import ButtonBase from '../ButtonBase';
const LinkButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    disabled,
    href: hrefProp,
    fluid
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  const href = !disabled ? hrefProp : undefined;
  return /*#__PURE__*/React.createElement(ButtonBase, _extends({
    ref: ref,
    disabled: disabled,
    href: href,
    fluid: fluid
  }, rest), children);
});
LinkButton.displayName = 'LinkButton';
LinkButton.kinds = ButtonBase.kinds;
LinkButton.sizes = ButtonBase.sizes;
LinkButton.defaultProps = {
  children: '',
  kind: LinkButton.kinds.primary,
  as: 'a',
  fluid: false
};
process.env.NODE_ENV !== "production" ? LinkButton.propTypes = {
  /**
   * Set element type to be rendered for this component. By default it will render a `a` element.
   */
  as: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),

  /**
   * Sets button children
   */
  children: PropTypes.node,

  /**
   * Sets button kind for styling
   */
  kind: PropTypes.oneOf([LinkButton.kinds.primary, LinkButton.kinds.secondary, LinkButton.kinds.tertiary, LinkButton.kinds.neutral, LinkButton.kinds.danger]),

  /**
   * Sets the button size
   */
  size: PropTypes.oneOf([LinkButton.sizes.sm, LinkButton.sizes.md]),

  /**
   * Makes LinkButton full-width
   */
  fluid: PropTypes.bool
} : void 0;
export default LinkButton;